const validationRegEx = /.+@.+\..+/

export function emailInputIsValid(input: string) {
  return validationRegEx.test(input)
}
